<!-- House Bill of Lading Format -->
<div class="house-bill-container">
  <div class="bill-page" *ngFor="let invoice of invoices; let i = index">

    <!-- Header Section -->
    <div class="bill-header">
      <div class="header-left">
        <span class="bill-label">HOUSE BILL OF LADING</span>
      </div>
      <div class="header-right">
        <span class="print-label">Print All</span>
      </div>
    </div>

    <!-- Company Logo and Title Section -->
    <div class="company-section">
      <div class="company-logo">
        <div class="logo-circle">
          <span class="logo-text">ISL</span>
        </div>
        <div class="company-info">
          <h3>Imperial</h3>
          <h3>Solutions</h3>
          <p>PROSPERITY FOR ALL</p>
        </div>
      </div>

      <div class="bill-title">
        <h1>HOUSE BILL OF LADING</h1>
      </div>
    </div>

    <!-- Bill Information Section -->
    <div class="bill-info-section">
      <div class="bill-number">
        <label>BL NO.:</label>
        <span>{{ getBillOfLadingNumber(invoice) }}</span>
      </div>
    </div>

    <!-- Main Information Table -->
    <div class="main-table-container">
      <table class="main-table">

        <!-- Shipper Information -->
        <tr>
          <td class="label-cell" rowspan="6">SHIPPER</td>
          <td class="data-cell">
            <strong>IMPERIAL SOLUTIONS LTD</strong><br>
            2F-24 AOBADAI, KITAKU KOBE 651-1231<br>
            JAPAN<br>
            TEL: +81-78-201-5360 FAX: +81-78-201-5361<br>
            EMAIL: INFO@IMPERIALSOLUTIONS.JP
          </td>
          <td class="label-cell">VESSEL NAME & VOYAGE NUMBER</td>
        </tr>

        <tr>
          <td class="data-cell">
            <strong>NOTIFY PARTY:</strong><br>
            SAME AS CONSIGNEE
          </td>
          <td class="data-cell">{{ getVesselName() }} - {{ getVoyageNumber() }}</td>
        </tr>

        <tr>
          <td class="data-cell">
            <strong>OCEAN BILL AUTO MEMO:</strong><br>
            AS AGENT TRADE AND FORWARDER<br>
            AT VESSEL TRADE AND FORWARDER, ST CATHERINE KINGSTON JAMAICA
          </td>
          <td class="label-cell">DISCHARGING PORT AND COUNTRY</td>
        </tr>

        <tr>
          <td class="data-cell">
            <strong>CONSIGNEE:</strong><br>
            {{ safeGet(invoice, 'customer.name', 'CUSTOMER NAME') }}<br>
            {{ safeGet(invoice, 'customer.address', 'CUSTOMER ADDRESS') }}<br>
            {{ safeGet(invoice, 'customer.city', '') }} {{ safeGet(invoice, 'customer.country', '') }}
          </td>
          <td class="data-cell">KINGSTON, JAMAICA</td>
        </tr>

        <tr>
          <td class="data-cell">
            <strong>NOTIFY PARTY (WITHOUT LIABILITY TO CARRIER):</strong><br>
            SAME AS CONSIGNEE
          </td>
          <td class="label-cell">PLACE OF DELIVERY</td>
        </tr>

        <tr>
          <td class="data-cell">
            <strong>ALSO NOTIFY:</strong><br>
            IMPERIAL SOLUTIONS LTD<br>
            2F-24 AOBADAI, KITAKU KOBE 651-1231<br>
            JAPAN<br>
            EMAIL: INFO@IMPERIALSOLUTIONS.JP<br>
            NOTIFY PARTY (WITHOUT LIABILITY TO CARRIER)
          </td>
          <td class="data-cell">ANY PORT IN JAMAICA</td>
        </tr>

        <!-- Port Information -->
        <tr>
          <td class="label-cell">LOADING PORT AND COUNTRY</td>
          <td class="data-cell">YOKOHAMA, JAPAN</td>
          <td class="label-cell">ETD</td>
        </tr>

        <tr>
          <td class="data-cell">YOKOHAMA, JAPAN</td>
          <td class="data-cell">{{ getCurrentDate() }}</td>
          <td class="data-cell">{{ getCurrentDate() }}</td>
        </tr>

      </table>
    </div>

    <!-- Cargo Details Table -->
    <div class="cargo-table-container">
      <table class="cargo-table">

        <!-- Table Headers -->
        <tr>
          <td class="cargo-header">MARKS AND NUMBERS</td>
          <td class="cargo-header">NUMBER AND KIND OF PACKAGES; FREIGHT UNITS; DESCRIPTION OF GOODS AND COMMODITIES</td>
          <td class="cargo-header">GROSS WEIGHT</td>
        </tr>

        <!-- Cargo Data - Individual Mode -->
        <tr *ngIf="viewMode !== 'merged' || !invoice.vehicles" class="cargo-row">
          <td class="cargo-data">
            {{ invoice.vehicle?.chassis_no || '' }}
          </td>
          <td class="cargo-data">
            <strong>1 USED VEHICLE</strong><br>
            MAKE: {{ invoice.vehicle?.make || '' }}<br>
            MODEL: {{ invoice.vehicle?.model || '' }}<br>
            YEAR: {{ invoice.vehicle?.year || '' }}<br>
            CHASSIS NO: {{ invoice.vehicle?.chassis_no || '' }}<br>
            ENGINE NO: {{ invoice.vehicle?.engine || '' }}
          </td>
          <td class="cargo-data">
            1,171 KGS
          </td>
        </tr>

        <!-- Cargo Data - Merged Mode -->
        <tr *ngIf="viewMode === 'merged' && invoice.vehicles" class="cargo-row">
          <td class="cargo-data">
            <div *ngFor="let vehicle of invoice.vehicles; let idx = index" class="vehicle-mark">
              {{ idx + 1 }}. {{ vehicle.chassis_no }}
            </div>
          </td>
          <td class="cargo-data">
            <strong>{{ getTotalPackages(invoice) }} USED VEHICLES</strong><br>
            <div *ngFor="let vehicle of invoice.vehicles; let idx = index" class="vehicle-details">
              <strong>{{ idx + 1 }}.</strong> {{ vehicle.make }} {{ vehicle.model }} ({{ vehicle.year }})<br>
              CHASSIS: {{ vehicle.chassis_no }}<br>
            </div>
          </td>
          <td class="cargo-data">
            {{ getTotalPackages(invoice) * 1171 }} KGS
          </td>
        </tr>

        <!-- Additional Information Row -->
        <tr>
          <td class="cargo-data"></td>
          <td class="cargo-data">
            <strong>GROSS WEIGHT:</strong><br>
            USED VEHICLES<br>
            MAKE: VARIOUS<br>
            MODEL: VARIOUS<br>
            YEAR: VARIOUS
          </td>
          <td class="cargo-data">
            GROSS WEIGHT
          </td>
        </tr>

      </table>
    </div>

    <!-- Terms and Conditions -->
    <div class="terms-section">
      <div class="terms-text">
        <strong>PLEASE NOTE:</strong><br>
        THIS BILL OF LADING THAT THIS VEHICLE HAS BEEN SHIPPED<br>
        UNDER THE TERMS AND CONDITIONS OF THE OCEAN BILL OF LADING FREIGHT<br>
        APPLICATION ON ANY OTHER PORT CLEARING PROCESSES
      </div>

      <div class="signature-area">
        <div class="signature-stamp">
          <div class="stamp-placeholder">
            [STAMP]
          </div>
        </div>
        <div class="authorized-signature">
          <p><strong>AUTHORIZED</strong></p>
          <p><strong>Imperial Solutions</strong></p>
          <p><strong>D.S SETHI</strong></p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="bill-footer">
      <div class="page-info">
        <span>Page No. 1</span>
      </div>
      <div class="footer-icons">
        <span class="icon">📄</span>
        <span class="icon">🖨️</span>
      </div>
    </div>

    <!-- Page Break (except for last invoice) -->
    <div class="page-break" *ngIf="i < invoices.length - 1"></div>

  </div>
</div>
